import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import StandardModal from 'components/consumer/StandardModal';
import useScreen from 'hooks/useScreen';
import IconAffirmLogo from 'components/icons/iconAffirmLogo';
import KeySellingPointsBarItem from '../KeySellingPointsBarItem';
const BuyNowPayLaterItem = t0 => {
  const $ = _c(13);
  const {
    openMobileModal
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAffirmLogo color="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMobileOrTablet || $[2] !== openMobileModal) {
    t2 = <KeySellingPointsBarItem icon={t1} onClick={() => {
      if (isMobileOrTablet) {
        openMobileModal({
          content: "",
          icon: <IconAffirmLogo color="white" />,
          cta: <>Unlock your exclusive financing offer in seconds with affirm. Rates from 0-36% APR. Payment options through Affirm are subject to an eligibility check and are provided by these lending partners:{" "}<a href="https://www.affirm.com/lenders" target="_blank" className="text-white underline" rel="noreferrer">affirm.com/lenders</a><div className="mt-6"><CtaLink to="/product-financing/" styling="solid-button" color="brand">Learn More</CtaLink></div></>
        });
      } else {
        setIsOpen(true);
      }
    }}>Financing as low as 0% APR</KeySellingPointsBarItem>;
    $[1] = isMobileOrTablet;
    $[2] = openMobileModal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="KeySellingPointsBarItem-modal-icon"><IconAffirmLogo color="white" /></div>;
    t4 = () => {
      setIsOpen(false);
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <a href="https://www.affirm.com/lenders" target="_blank" className="text-white underline" rel="noreferrer">affirm.com/lenders</a>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="m-0 mt-6"><CtaLink to="/product-financing/" styling="solid-button" color="brand" onClick={() => setIsOpen(false)}>Learn More</CtaLink></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isOpen) {
    t7 = <StandardModal isOpen={isOpen} icon={t3} onClose={t4} title="Financing as low as 0% APR">Unlock your exclusive financing offer in seconds with affirm. Rates from 0-36% APR. Payment options through Affirm are subject to an eligibility check and are provided by these lending partners:{" "}{t5}{t6}</StandardModal>;
    $[8] = isOpen;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t2 || $[11] !== t7) {
    t8 = <>{t2}{t7}</>;
    $[10] = t2;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
BuyNowPayLaterItem.propTypes = {
  openMobileModal: PropTypes.func
};
export default BuyNowPayLaterItem;